import { getCareLibrarySourceCollectedCount, getCareLibrarySourceCollectedRows, getCareLibrarySourceSavedLabel, getCareLibrarySourceTitle } from "./careLibraryDisplayModel";

const normalize = (value = "") => String(value || "").replace(/\s+/g, " ").trim();

export const getDocumentFileName = (source = {}) => normalize(source.sourceMetadata?.fileName || source.metadata?.source?.fileName || source.fileName || "Document");

export const getDocumentSourceGroup = (source = {}) => {
  if (source.metadata?.source?.originConfirmedByCaregiver === false) return "Unsorted";
  const explicit = normalize(source.metadata?.source?.confirmedOriginName || source.sourceMetadata?.confirmedOriginName || source.sourceMetadata?.sourceName || source.metadata?.source?.sourceName || source.sourceName);
  if (explicit && !/^(file import|document|uploaded file)$/i.test(explicit)) return explicit;
  const documentType = normalize(source.documentType || source.sourceMetadata?.documentType || source.metadata?.source?.documentType).toLowerCase();
  if (documentType === "school_document") return "School";
  if (documentType === "doctor_note") return "Doctor";
  return "Unsorted";
};

export const getDocumentEventCount = (source = {}) => {
  if (Object.prototype.hasOwnProperty.call(source.importHistoryReviewResult || {}, "approvedCount")) return Number(source.importHistoryReviewResult.approvedCount || 0);
  if (Object.prototype.hasOwnProperty.call(source.pendingTimelineReview || {}, "candidateCount")) return Number(source.pendingTimelineReview.candidateCount || 0);
  return Number(source.extractionSummary?.savedRecordCount || getCareLibrarySourceCollectedCount(source) || 0);
};

export const getDocumentReviewStatus = (source = {}) => {
  if (source.importHistoryReviewResult?.version > 0 || source.reviewState === "reviewed") return "Reviewed";
  if (source.pendingTimelineReview?.candidateCount > 0 || source.reviewState === "needs_review") return "Needs review";
  if (getDocumentEventCount(source) < 1) return "No events found";
  return "Reviewed";
};

const getExtractedEventRows = (source = {}) => {
  const candidates = source.pendingTimelineReview?.candidates || [];
  const suggestions = candidates.length
    ? candidates.map((candidate) => candidate.suggestedRecord)
    : (source.extractionResult?.suggestedRecords || source.metadata?.captureFirst?.suggestedRecords || []);
  return suggestions.flatMap((suggestion, index) => {
    const record = suggestion?.record || suggestion || {};
    const title = normalize(suggestion?.title || record.title || `Event ${index + 1}`);
    const subtitle = normalize(record.text || record.note || record.summary || suggestion?.sourceText);
    if (!title && !subtitle) return [];
    return [{ id: suggestion?.id || suggestion?.key || `event-${index}`, title, subtitle, localDate: normalize(record.localDate), category: normalize(record.category) }];
  });
};

export const buildDesktopDocumentRows = (sources = []) => sources.map((source) => ({
  id: source.id,
  source,
  title: getCareLibrarySourceTitle(source),
  fileName: getDocumentFileName(source),
  savedLabel: getCareLibrarySourceSavedLabel(source).replace(/^SAVED\s+/i, "Saved "),
  group: getDocumentSourceGroup(source),
  eventCount: getDocumentEventCount(source),
  status: getDocumentReviewStatus(source),
  extractedRows: getExtractedEventRows(source).length ? getExtractedEventRows(source) : getCareLibrarySourceCollectedRows(source),
}));

export const groupDesktopDocumentRows = (rows = []) => {
  const groups = new Map();
  [...rows].sort((left, right) => {
    const toMillis = (value) => value?.toMillis?.() || value?.seconds * 1000 || new Date(value || 0).getTime() || 0;
    return toMillis(right.source.capturedAt || right.source.createdAt) - toMillis(left.source.capturedAt || left.source.createdAt);
  }).forEach((row) => groups.set(row.group, [...(groups.get(row.group) || []), row]));
  return [...groups.entries()].map(([label, items]) => ({ label, items }));
};
